import { Link as ChakraLink, LinkProps as ChakraLinkProps } from "@chakra-ui/react";
import { Link as RouterLink } from "react-router-dom";
import { useDefaultStyle } from "hooks";
import { FC, useMemo } from "react";
import { when } from "utils";

export interface LinkProps extends ChakraLinkProps {
  to?: string;
  disabled?: boolean;
}

const Link: FC<LinkProps> = (props) => {
  const { to, disabled } = props;
  const { shadow } = useDefaultStyle();

  const as = useMemo(() => when<any>(!to, "button", when<any>(!!disabled, "button", RouterLink)), [to, disabled]);
  return (
    <ChakraLink
      cursor="pointer"
      as={as}
      borderRadius="2px"
      display="inline-block"
      disabled={disabled}
      _disabled={{ opacity: 0.4 }}
      _focus={{ shadow }}
      {...props}
    >
      {props.children}
    </ChakraLink>
  );
};

export default Link;
